import api from "@/services/api";

import { ClientDetailsType } from "@/types/client/Client";

class CreateClient {
  execute = async (client: ClientDetailsType) => {
    const payload: any = {};

    // Só adiciona os campos se eles existirem e não estiverem vazios
    if (client.name && client.name.trim()) {
      payload.name = client.name;
    }
    if (client.phone && client.phone.trim()) {
      payload.phone = client.phone;
    }
    if (client.email && client.email.trim()) {
      payload.email = client.email;
    }
    if (client.document && client.document.trim()) {
      payload.document = client.document;
    }

    // Obter indicationKey do session info
    const sessionInfo = await api().get(`/auth/session-info`);
    if (sessionInfo.data.indicationKey) {
      payload.indicatorKey = sessionInfo.data.indicationKey;
    }

    // Sempre enviar indicatorType como PARTNER
    payload.indicatorType = "PARTNER";
    const clientSend = await api().post(`/customer/pre-registration`, payload);
    return clientSend.data as ClientDetailsType;
  };
}

export { CreateClient };
